import { Typography } from '@altibox/design-system-component-lib';
import { styled } from 'styled-components';

import { breakpointTablet } from 'app/style/breakpoints';
import { spacing1, spacing16, spacing2, spacing3, spacing4, spacing6, spacing7, spacing8 } from 'app/style/spacing';
import { Container } from 'app/components/container';

export const StyledContainer = styled(Container)`
    margin-top: ${spacing3};
    margin-bottom: ${spacing6};

    @media (min-width: ${breakpointTablet}) {
        margin-top: ${spacing8};
        margin-bottom: ${spacing16};
    }
`;

export const StyledHeading = styled(Typography)`
    text-align: center;
    margin-bottom: ${spacing7};
`;

export const StyledNote = styled(Typography)`
    margin-top: ${spacing1};
    font-style: italic;
    text-align: justify;

    @media (min-width: ${breakpointTablet}) {
        margin-top: ${spacing4};
    }
`;

export const StyledButtonContainer = styled.div`
    margin-top: ${spacing4};
    margin-bottom: ${spacing2};
    display: flex;
    justify-content: center;

    @media (min-width: ${breakpointTablet}) {
        margin-top: ${spacing6};
        margin-bottom: ${spacing4};
    }
`;

export const StyledTerms = styled(Typography)`
    text-align: center;
`;

export const StyledDisclaimer = styled(Typography)`
    text-align: center;
`;
